import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, Dimensions, Button, Alert, Platform } from 'react-native';
import Amplify, { Auth } from 'aws-amplify';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Linking } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import LoginButtonInput from '../components/LoginButtonInput';
import LoginButton from '../components/LoginButton';
import SignUpButton from '../components/SignUpButton';
import mainIcon from '../assets/uploadifierSymbol.png';
import { ScrollView } from 'react-native-gesture-handler';
import PhoneInput from 'react-phone-number-input/react-native-input';
import validate from 'validate.js';
import { isPossiblePhoneNumber } from 'react-phone-number-input';


export default function CreateAccount({ navigation }) {
  //var country_code = "+1" ;
  var username; 

  const [phone_number, setPhone_number] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  var accountnullcaseCounter = 0

  async function login() {
    try {
      await Auth.signIn(username, password);
      console.log('Authentication Success, User has logged in properly');
      updateAuthState('loggedIn');
      
      
    } catch (error) {
      console.log(' Error signing in...', error);
    }
  }
  
  
  async function signUp() {

    accountnullcaseCounter = 0;
  
    var constraints = {
      from: {
        email: true
      }
    };

   
    try {
      var username = email;

      if (email === ''){
        accountnullcaseCounter = accountnullcaseCounter + 1;
        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          console.log('email field cannot be empty')
          Alert.alert('Email cannot be empty')
        }
        if (Platform.OS === 'web'){
          console.log('email field cannot be empty')
          alert('Email cannot be empty')
        }
        

        
      }

      

      if (email !== '' && email !== null){
        accountnullcaseCounter = accountnullcaseCounter + 1;
        const validationResult = validate({from: email}, constraints)
        console.log(validationResult);
        if (typeof validationResult !== 'undefined'){
          if (Platform.OS === 'android' || Platform.OS === 'ios'){
            Alert.alert('Invalid Email')
          }
          if (Platform.OS === 'web'){
            alert('Invalid Email')
          }
        
        }
      }
      

      if (typeof phone_number !== undefined && phone_number !== null){
        if (isPossiblePhoneNumber(phone_number) !== true){
          accountnullcaseCounter = accountnullcaseCounter + 1;
          if (Platform.OS === 'android' || Platform.OS === 'ios'){
            console.log('not a possible valid phone number')
            Alert.alert("Please enter a valid US phone number");
          }
          if (Platform.OS === 'web'){
            console.log('not a possible valid phone number')
            alert("Please enter a valid US phone number");
          }
        }
      }


      if (password === ''){
        accountnullcaseCounter = accountnullcaseCounter + 1;
        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          console.log('password is null')
          Alert.alert("Please enter a password");
        }
        if (Platform.OS === 'web'){
          console.log('password is null')
          alert("Please enter a password");
        }
      }

      if (isPossiblePhoneNumber(phone_number) === true && typeof validationResult === 'undefined' && password !== '') {

     
      //phone_number = country_code.concat("",phone_number);
      await Auth.signUp({ username, password, attributes: { email, phone_number } });
      console.log(' Sign-up Confirmed');
      navigation.navigate('ConfirmCreateAccount');
      //this is for testing login only. If you enable this in prod, 
      //you will be sending a pw in clear text.
      // that is sub optimal
      //console.log( username, password, email, phone_number)
      }
      

    } 

    
    
    catch (error) {
      console.log(' Error signing up...', error);
      console.log(error.name);
      
        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          if (error.name === 'InvalidParameterException'){
            Alert.alert('include at least 1 uppercase letter 1 lowercase letter and 1 number')
            Alert.alert('Password needs to be at least 8 Characters and')
          }
        }
        if (Platform.OS === 'web'){
          if (error.name === 'InvalidParameterException'){
          alert('Password needs to be at least 8 Characters and include at least 1 uppercase letter 1 lowercase letter and 1 number')
          }
        }
      

        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          if (error.name === 'InvalidPasswordException'){
            Alert.alert('include at least 1 uppercase letter 1 lowercase letter and 1 number')
            Alert.alert('Password needs to be at least 8 Characters and')
          }
        }
        if (Platform.OS === 'web'){
          if (error.name === 'InvalidPasswordException'){
          alert('Password needs to be at least 8 Characters and include at least 1 uppercase letter 1 lowercase letter and 1 number')
          }
        }

        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          if (error.name === 'UserNotConfirmedException' ){
            await Auth.resendSignUp(email);
            //await Auth.signUp({ username, password, attributes: { email, phone_number } });
              console.log(' resent conf code for '+ username);
            Alert.alert('If this is a valid account, please check your email')
          }
        }
        if (Platform.OS === 'web'){
          if (error.name === 'UserNotConfirmedException'){
            await Auth.resendSignUp(email);
            //await Auth.signUp({ username, password, attributes: { email, phone_number } });
              console.log(' resent conf code for '+ username);
          alert('If this is a valid account, please check your email')
          }
        }

        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          if (error.name === 'UsernameExistsException' ){
            Alert.alert('If this is a valid account, please check your email')
          }
        }
        if (Platform.OS === 'web'){
          if (error.name === 'UsernameExistsException'){
            Alert.alert('If this is a valid account, please check your email')
          }
        }

      
    }

    

  }
   

  async function resendConf() {
    await Auth.resendSignUp(email);
    //await Auth.signUp({ username, password, attributes: { email, phone_number } });
      console.log(' resent conf code for '+ username);
      navigation.navigate('ConfirmCreateAccount');
  }  
    return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <Text style={styles.title}>Create a new account</Text>
        <LoginButtonInput
          value={email}
          onChangeText={text => setEmail(text)}
          leftIcon="email"
          placeholder="Enter email address"
          autoCapitalize="none"
          keyboardType="email-address"
          textContentType="emailAddress"
        />

        <PhoneInput
        style={styles.phone}
          country="US"
          leftIcon="phone"
          placeholder="Enter Phone Number"
          placeholderTextColor='#6e6869'
          value={phone_number}
          onChange={setPhone_number}
        />

        <LoginButtonInput
          value={password}
          onChangeText={text => setPassword(text)}
          leftIcon="lock"
          placeholder="Enter password"
          autoCapitalize="none"
          autoCorrect={false}
          secureTextEntry
          textContentType="password"
        />

        <SignUpButton 
          title="Sign Up" 
          onPress={signUp} 
        />

        <LoginButton 
          title="Take me back to Login" 
          onPress={() => navigation.navigate("Login")}
        />

        <ScrollView 
          style={styles.warningTextScroll}
          >
            
        
          <Text 
            style={styles.warningText}>
          
           If you are under 18, and have been sent adult content or hate speech, 
           please inform a parent or guardian
           instead of using this app. {'\n'}
           If you believe that you have been sent content that may be from a person under 
           the age of consent this app is not the right place for it to be reported. {'\n'}
           Please notify your local authorities instead. {'\n'}
           Please use this application only to submit complaints of actual non consensual behavior. {'\n'}
           By creating an account and using this app you are acknowledging that you acccept, and will abide by our terms of service.{'\n'}
          Click below to view our terms of service and privacy policy
          
          </Text>
        </ScrollView>

          <Text 
            style={styles.termsText}
            onPress={() => Linking.openURL('https://privacyterms.io/view/zKol8S2I-zjYiI1oO-SIj3Pg/')}>
            Uploadifier Terms and Conditions
          </Text>

          <Text 
            style={styles.termsText}
            onPress={() => Linking.openURL('https://privacyterms.io/view/yvYB2VDn-64kRmjuk-ght6dy/')}>
            Uploadifier Privacy Policy
          </Text>

        <View style={styles.footerButtonContainer}>        
         
        </View>
        
      </View>
    </SafeAreaView>
  );
}



const styles = EStyleSheet.create({
  column: {
    width: '80%'                                    // 80% of screen width
  },
  text: {
    color: '$textColor',                            // global variable $textColor
    fontSize: '1.5rem'                              // relative REM unit
  },
      safeAreaContainer: {
        flex: 1,
        backgroundColor: 'white'
      },
      phone: {
        backgroundColor: '#f9f9f9',
        borderRadius: 25,
        flexDirection: 'row',
        padding: '.9rem',
        marginVertical: '.25rem',
        width: '20rem',
        height: '3rem',
        fontSize: '1.15rem',
        color: '#101010'
      },
      container: {
        flex: 1,
        alignItems: 'center'
      },
      title: {
        fontSize: 20,
        //color: '#202020',
        color: "mediumblue",
        fontWeight: '500',
        marginVertical: 15
      },
      footerButtonContainer: {
        marginVertical: 15,
        justifyContent: 'center',
        alignItems: 'center'
      },
      warningText: {
        color: '$textColor',
        //fontSize: 18,
        //fontWeight: '600',
        width: '75%',
        height: '100%',
        fontSize: '.8rem'
      },
      warningTextScroll: {
        color: '$textColor',
        //fontSize: 18,
        //fontWeight: '600',
        width: '90%',
        height: '65%',
        fontSize: '1rem',
      },
      termsText: {
        color: 'mediumblue',
        fontSize: 18,
        fontWeight: '600',
        marginVertical: 10,
        width: '90%'
      }
    });

